import axiosInstance from "@/axiosConfig";
import { getApiUrl } from "@/shared/utils/api";

export type EmployeeIbanResponse = {
  client_id: number
  iban: string
  bic: string
  iban_verified: boolean
  bic_calcule: string
  iban_reason?: string | null
};

export type UpdateEmployeeIbanPayload = {
  iban?: string
  bic?: string
  verify?: boolean
};

type EmployeeId = string | number;

const verifyUrl = (employeeId: EmployeeId) => `/employees/${employeeId}/verify_iban`;
const updateUrl = (employeeId: EmployeeId) => `/employees/${employeeId}/update_iban`;

export const EmployeeIbanService = {
  verify: async (employeeId: EmployeeId): Promise<EmployeeIbanResponse> => {
    const response = await axiosInstance.post<EmployeeIbanResponse>(
      getApiUrl(verifyUrl(employeeId)),
    );
    return response.data;
  },

  update: async (
    employeeId: EmployeeId,
    data: UpdateEmployeeIbanPayload,
  ): Promise<EmployeeIbanResponse> => {
    const response = await axiosInstance.patch<EmployeeIbanResponse>(
      getApiUrl(updateUrl(employeeId)),
      data,
    );
    return response.data;
  },
};
